export default __webpack_public_path__ + "static/media/gallery_13.5264f290.jpg";